/**
 * @deprecated Use Loader from @upsales/components directly.
 *
 * Moved out of the Angular tree in WEB-8861 so the ReactTemplates.loader global could survive
 * Phase 6. WEB-9997 converted every reader to import it and removed the global, so this is now a
 * plain component with no window coupling.
 */
import React from 'react';
import { Loader } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';

const OldLoader = ({ className, noU, ...props }) => {
	const classes = new bemClass('upsales-loader', className);
	let size = 'md';

	if (noU) {
		size = 'sm';
	}

	return <Loader {...props} size={size} className={classes.b()} />;
};

export default OldLoader;
